/** @jsxImportSource @emotion/react */
import estyled from '@signal/theme/emotion'
import { TransitionGroup } from 'react-transition-group'

export const TransitionContainer = estyled(TransitionGroup)`
  position: relative;
  height: 100%;
`
